import { Dialog, Box, Button } from "@mui/material";

const ones = ["","One","Two","Three","Four","Five","Six","Seven","Eight","Nine",
  "Ten","Eleven","Twelve","Thirteen","Fourteen","Fifteen","Sixteen","Seventeen",
  "Eighteen","Nineteen"];
const tens = ["","","Twenty","Thirty","Forty","Fifty","Sixty","Seventy","Eighty","Ninety"];

function numToWords(n) {
  n = Math.round(n);
  if (n === 0) return "Zero";
  if (n < 20)       return ones[n];
  if (n < 100)      return tens[Math.floor(n/10)] + (n%10 ? " " + ones[n%10] : "");
  if (n < 1000)     return ones[Math.floor(n/100)] + " Hundred" + (n%100 ? " " + numToWords(n%100) : "");
  if (n < 100000)   return numToWords(Math.floor(n/1000)) + " Thousand" + (n%1000 ? " " + numToWords(n%1000) : "");
  if (n < 10000000) return numToWords(Math.floor(n/100000)) + " Lac" + (n%100000 ? " " + numToWords(n%100000) : "");
  return numToWords(Math.floor(n/10000000)) + " Crore" + (n%10000000 ? " " + numToWords(n%10000000) : "");
}

const toWords = (amount) => {
  const [intPart, decPart] = Number(amount).toFixed(2).split(".");
  let words = "Rupees " + numToWords(parseInt(intPart));
  if (decPart && parseInt(decPart) > 0) words += " and " + numToWords(parseInt(decPart)) + " Paise";
  return words + " Only";
};

const fmt = (n) =>
  Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const fmtDate = (d) => {
  if (!d) return "—";
  return new Date(d).toLocaleDateString("en-IN", {
    day: "2-digit", month: "2-digit", year: "numeric"
  }).replace(/\//g, "-");
};

const getShopAddress = (location) => {
  if (location === "Mahisadal") {
    return {
      line1: "VILL + P.O.- AJRA, MAHISADAL",
      line2: "DIST.- EAST MEDINIPUR, WEST BENGAL, 721628",
      contact: "7047233089 / 4779148045",
      gstin: "19DKBPG0462C1ZN",
      bankName: "SBI (State Bank of India)",
      acName: "BANKALI ENTERPRISE",
      acNo: "44575012276",
      ifsc: "SBIN0012455",
    };
  }
  if (location === "Boroda") {
    return {
      line1: "VILL + P.O.- CHAITANYAPUR (BARADA RAIL GATE), SUTAHATA",
      line2: "DIST.- EAST MEDINIPUR, WEST BENGAL, 721658",
      contact: "7047233089 / 4779148045",
      gstin: "19DKBPG0462C1ZN",
      bankName: "SBI (State Bank of India)",
      acName: "BANKALI ENTERPRISE",
      acNo: "44575012276",
      ifsc: "SBIN0012455",
    };
  }
  return {
    line1: "VILL + P.O.- CHAITANYAPUR (RAMPUR), SUTAHATA",
    line2: "DIST.- EAST MEDINIPUR, WEST BENGAL, 721658",
    contact: "7047233089 / 4779148045",
    gstin: "19DKBPG0462C1ZN",
    bankName: "SBI (State Bank of India)",
    acName: "BANKALI ENTERPRISE",
    acNo: "44575012276",
    ifsc: "SBIN0012455",
  };
};

const InvoicePopup = ({ open, onClose, data }) => {
  if (!data) return null;
// console.log(data)
  const location  = data.bike?.location || "";
  const shopAddr  = getShopAddress(location);

  const saleType    = data.payment?.saleType || "";
  const hasFinance  = (saleType === "FINANCE" || saleType === "EX+FIN") && data.payment?.finance;
  const financeInfo = hasFinance ? data.payment.finance : null;
  const downPayment = Number(data.payment?.finance?.financeDown || 0);

  const v = (val) => (val && val !== "-" ? val : "");

  const addressLine = [
    v(data.customer.village)       ? "VILL-"  + data.customer.village.toUpperCase()       : "",
    v(data.customer.postOffice)    ? "P.O-"   + data.customer.postOffice.toUpperCase()    : "",
    v(data.customer.policeStation) ? "P.S-"   + data.customer.policeStation.toUpperCase() : "",
    v(data.customer.pinCode)       ?            data.customer.pinCode                      : "",
  ].filter(Boolean).join(", ");

  const invoiceDate = fmtDate(data.invoice.date);

  const cp  = "padding:8px 10px";
  const cps = "padding:4px 10px";
  const cph = "padding:6px 10px";
  const f11 = "font-size:11px";
  const f12 = "font-size:12px";
  const f13 = "font-size:13px";
  const f14 = "font-size:14px";

  const b         = data.bike;
  const batteries = data.battery || [];
  const chargerD  = data.charger  || null;

  /* ─────────────────────────────────────────────────────────────────────────
     DESCRIPTION table rows (top detail block)
  ───────────────────────────────────────────────────────────────────────── */
  const descRows = () => {
    const rows = [];

    if (b?.HSN) {
      rows.push(`
        <tr>
          <td style="border:1px solid #000;border-top:none;${cps};font-weight:900;${f13};">HSN CODE</td>
          <td style="border:1px solid #000;border-top:none;border-left:none;${cps};${f13};" colspan="3">${b.HSN ? b.HSN : "—"}</td>
        </tr>`);
    }

    if (financeInfo) {
      rows.push(`
        <tr>
          <td style="border:1px solid #000;border-top:none;${cps};font-weight:900;${f13};">FINANCE BY</td>
          <td style="border:1px solid #000;border-top:none;border-left:none;${cps};${f13};" colspan="3">${financeInfo ? financeInfo.company.toUpperCase() : "—"}</td>
        </tr>`);
    }

    if (downPayment > 0 && financeInfo) {
      rows.push(`
        <tr>
          <td style="border:1px solid #000;border-top:none;${cps};font-weight:900;${f13};">FINANCE DOWN PAYMENT</td>
          <td style="border:1px solid #000;border-top:none;border-left:none;${cps};${f13};">&#8377;  ${fmt(downPayment)} (CASH)</td>
          <td style="border:1px solid #000;border-top:none;border-left:none;${cps};font-weight:900;${f13};"> FINANCE AMOUNT</td>
          <td style="border:1px solid #000;border-top:none;border-left:none;${cps};${f13};">${fmt(financeInfo.amount)}</td>
        </tr>`);
    }

    if (financeInfo) {
      rows.push(`
        <tr>
          <td style="border:1px solid #000;border-top:none;${cps};font-weight:900;${f13};">EMI</td>
          <td style="border:1px solid #000;border-top:none;border-left:none;${cps};${f13};">&#8377; ${fmt(financeInfo.emiAmount)+`  × ${financeInfo.months}`}</td>
          <td style="border:1px solid #000;border-top:none;border-left:none;${cps};font-weight:900;${f13};">1ST EMI DATE</td>
          <td style="border:1px solid #000;border-top:none;border-left:none;${cps};${f13};">${financeInfo.date ? fmtDate(financeInfo.date) : "—"}</td>
        </tr>`);
    }

    return rows.join("");
  };

  /* ─────────────────────────────────────────────────────────────────────────
     DESCRIPTION OF GOODS cell
     - Battery 1: full details (company | model | type | S/N | warranty)
     - Battery 2, 3, …: invoice badge + S/N line only
  ───────────────────────────────────────────────────────────────────────── */
  const buildDescriptionCell = () => {
    const lines = [];

    /* helper: small badge line for invoice numbers */
    const invBadge = (label, invoiceNo) =>
      `<div style="margin-bottom:2px;margin-top:6px;background:#e8e8e8;padding:2px 5px;border-radius:2px;display:inline-block;">
        <span style="${f11};font-weight:900;letter-spacing:0.5px;">${label}:</span>
        <span style="${f11};font-weight:700;margin-left:4px;">${invoiceNo || "—"}</span>
      </div>`;

    const lb = (label, val) =>
      `<div style="margin-bottom:2px;${f12};"><span style="font-weight:900;">${label}:</span> ${val}</div>`;

    /* ── EV section ── */
    lines.push(invBadge(
      b.vehicleType === "E_RICKSHAW" ? "E-RICKSHAW INVOICE" : "SCOOTY INVOICE",
      data.invoice.invoiceNo
    ));
    if (v(b.companyName)) lines.push(lb("BRAND", b.companyName.toUpperCase()));
    lines.push(
      `<div style="margin-bottom:2px;${f12};font-weight:900;">${b.model}${v(b.color) ? ` | ${String(b.color).toUpperCase()}` : ""} </div>`
    );
    if (v(b.chasis))
      lines.push(lb("CHASSIS", b.chasis + (b.motorWarranty ? ` – ${b.motorWarranty} Months` : "")));
    if (v(b.engine))
      lines.push(lb("ENGINE",  b.engine  + (b.motorWarranty ? ` – ${b.motorWarranty} Months` : "")));
    if (v(b.controllerNo) && b.controllerNo !== "-")
      lines.push(lb("CONTROLLER", b.controllerNo + (b.controllerWarranty ? ` – ${b.controllerWarranty} Months` : "")));

    /* ── Battery sections ── */
    batteries.forEach((bat, idx) => {
      const isFirst      = idx === 0;
      const isERickshaw  = b?.vehicleType === "E_RICKSHAW";
      const batLabel     = batteries.length > 1 ? `BATTERY ${idx + 1} INVOICE` : "BATTERY INVOICE";
      const batInvNo     = bat.sale?.invoiceNo || bat.invoiceNo || "";
      /* For E_RICKSHAW battery 2+: skip invoice badge */
      if (!isERickshaw || isFirst) {
        lines.push(invBadge(batLabel, batInvNo));
      }

      /* For SCOOTY: always full details (original behaviour)
         For E_RICKSHAW: Battery 1 full details, Battery 2+ S/N only */
      const showFullDetails = !isERickshaw || isFirst;

      if (showFullDetails) {
        /* Full details */
        const parts = [];
        if (bat.stock?.companyName)  parts.push(bat.stock.companyName.toUpperCase());
        if (bat.stock?.model)        parts.push(bat.stock.model);
        if (bat.stock?.batteryType)  parts.push(bat.stock.batteryType);
        if (bat.stock?.serialNo)     parts.push(`S/N: ${bat.stock.serialNo}`);
        if (bat.stock?.warrantyDate) parts.push(`WARRANTY: ${bat.stock.warrantyDate}  MONTHS`);
        if (parts.length) {
          lines.push(
            `<div style="margin-bottom:2px;${f12};">${parts.join(" | ")}</div>`
          );
        }
      } else {
        /* E_RICKSHAW Battery 2, 3, … — Battery N: S/N: xxxx */
        if (bat.stock?.serialNo) {
          lines.push(
            `<div style="margin-bottom:2px;${f12};"><span style="font-weight:900;">Battery ${idx + 1}:</span> S/N: ${bat.stock.serialNo}</div>`
          );
        }
      }
    });

    /* ── Charger section ── */
    if (chargerD?.stock) {
      const cs     = chargerD.stock;
      const cInvNo = chargerD.sale?.invoiceNo || chargerD.invoiceNo || "";
      lines.push(invBadge("CHARGER INVOICE", cInvNo));

      const parts = [];
      if (cs.companyName) parts.push(cs.companyName.toUpperCase());
      if (cs.model)       parts.push(cs.model);
      if (cs.serialNo)    parts.push(`S/N: ${cs.serialNo}`);
      if (cs.warrantyDate) parts.push(`WARRANTY: ${cs.warrantyDate}  MONTHS`);
      if (parts.length) {
        lines.push(
          `<div style="margin-bottom:2px;${f12};">${parts.join(" | ")}</div>`
        );
      }
    }

    return lines.join("");
  };

  /* ─────────────────────────────────────────────────────────────────────────
     HTML BUILDER
  ───────────────────────────────────────────────────────────────────────── */
  const getInvoiceHTML = (forPrint = false) => `
<div style="
  width:${forPrint ? "187mm" : "100%"};
  font-family:Arial,sans-serif;
  font-size:12px;
  color:#000;
  box-sizing:border-box;
  ${forPrint ? "margin:0 auto;" : ""}
">

  <!-- BORDERED INVOICE BODY -->
  <div style="border:2px solid #000;padding:${forPrint ? "7px 9px" : "9px 11px"};">

    <!-- TAX INVOICE LABEL -->
    <div style="text-align:center;font-size:10px;font-weight:bold;letter-spacing:4px;margin-bottom:4px;">
      TAX INVOICE
    </div>

    <!-- COMPANY HEADER -->
    <div style="display:flex;align-items:center;justify-content:space-between;border-bottom:2px solid #000;padding-bottom:8px;margin-bottom:0;">
      <img src="/bajaj.jpeg" style="height:38px;width:auto;object-fit:contain;" />
      <div style="text-align:center;flex:1;padding:0 10px;">
        <div style="font-size:32px;font-weight:900;font-family:'Arial Black',Arial,sans-serif;letter-spacing:1px;line-height:1.05;">BANKALI ENTERPRISE</div>
        <div style="${f11};margin-top:3px;">${shopAddr.line1}</div>
        <div style="${f11};">${shopAddr.line2}</div>
        <div style="${f11};">CONTACT NO.- ${shopAddr.contact} &nbsp;|&nbsp; EMAIL : mahadevghosh408@gmail.com</div>
        <div style="${f11};">GSTIN NO : ${shopAddr.gstin}</div>
      </div>
      <img src="/bajaj.jpeg" style="height:38px;width:auto;object-fit:contain;" />
    </div>

    <!-- BILL TO (67%) + INVOICE NO (33%) -->
    <table style="width:100%;border-collapse:collapse;">
      <tr>
        <td style="width:67%;vertical-align:top;border:1px solid #000;${cp};">
          <div style="${f11};font-weight:bold;margin-bottom:2px;">Bill to :</div>
          <div style="font-size:18px;font-weight:900;text-transform:uppercase;line-height:1.2;margin-bottom:5px;">${data.customer.name}</div>
          <div style="${f13};font-weight:bold;">ADDRESS:-</div>
          <div style="${f13};line-height:1.7;margin-top:3px;">${addressLine}</div>
          ${v(data.customer.address)
            ? `<div style="${f13};margin-top:2px;">${data.customer.address.toUpperCase()}</div>`
            : ""}
          ${v(data.customer.fatherName)
            ? `<div style="${f13};margin-top:4px;"><b>S/O:</b> ${data.customer.fatherName.toUpperCase()}</div>`
            : ""}
          <div style="${f13};margin-top:4px;"><b>Mobile:</b> ${(data.customer.mobile || []).join(", ")}</div>
          <div style="${f13};margin-top:3px;"><b>GSTIN :</b>${data.customer.gstin ? " " + data.customer.gstin : ""}</div>
        </td>
        <td style="width:33%;vertical-align:top;border:1px solid #000;border-left:none;${cp};text-align:center;">
          <div style="${f11};font-weight:bold;margin-bottom:4px;">INVOICE NO</div>
          <div style="font-size:15px;font-weight:900;margin-bottom:8px;">${data.invoice.invoiceNo}</div>
          <div style="${f11};font-weight:bold;margin-bottom:4px;">Dated</div>
          <div style="font-size:14px;font-weight:bold;">${invoiceDate}</div>
        </td>
      </tr>
    </table>

    <!-- PRICING TABLE — 4 columns -->
    <table style="width:100%;border-collapse:collapse;">
      <thead>
        <tr style="background:#e0e0e0;">
          <th style="border:1px solid #000;border-top:none;${cph};text-align:left;${f11};width:46%;">DESCRIPTION OF GOODS</th>
          <th style="border:1px solid #000;border-top:none;border-left:none;${cph};text-align:center;${f11};width:8%;">QTY</th>
          <th style="border:1px solid #000;border-top:none;border-left:none;${cph};text-align:left;${f11};width:28%;"></th>
          <th style="border:1px solid #000;border-top:none;border-left:none;${cph};text-align:right;${f11};width:18%;">AMOUNT</th>
        </tr>
      </thead>
      <tbody>

        <!-- ROW 1 — Description+QTY span 8 rows | BASE PRICE -->
        <tr>
          <td rowspan="8" style="border:1px solid #000;border-top:none;${cp};vertical-align:top;">
            ${buildDescriptionCell()}
          </td>
          <td rowspan="8" style="border:1px solid #000;border-top:none;border-left:none;${cp};${f12};text-align:center;vertical-align:top;">1</td>
          <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f12};font-weight:bold;">BASE PRICE</td>
          <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f12};text-align:right;">&#8377; ${fmt(data.pricing.basePrice)}</td>
        </tr>

        <!-- ROW 2 — DISCOUNT -->
        <tr>
          <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f12};">DISCOUNT</td>
          <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f12};text-align:right;">
            ${data.pricing.discount > 0 ? "&#8377; " + fmt(data.pricing.discount) : ""}
          </td>
        </tr>

        <!-- ROW 3 — TAXABLE AMOUNT -->
        <tr>
          <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f12};">TAXABLE AMOUNT</td>
          <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f12};text-align:right;">&#8377; ${fmt(data.pricing.taxableAmount)}</td>
        </tr>

        <!-- ROW 4 — CGST -->
        <tr>
          <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f12};">Add CGST @${data.pricing.cgstRate}%</td>
          <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f12};text-align:right;">&#8377; ${fmt(data.pricing.cgst)}</td>
        </tr>

        <!-- ROW 5 — SGST -->
        <tr>
          <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f12};">Add SGST @${data.pricing.sgstRate}%</td>
          <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f12};text-align:right;">&#8377; ${fmt(data.pricing.sgst)}</td>
        </tr>

        <!-- ROW 6 — TOTAL AMOUNT -->
        <tr>
          <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f13};font-weight:bold;">TOTAL AMOUNT</td>
          <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f13};font-weight:bold;text-align:right;">&#8377; ${fmt(data.pricing.totalAmount)}</td>
        </tr>

        <!-- ROW 7 — ROUND OFF -->
        <tr>
          <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f12};">ROUND OFF</td>
          <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f12};text-align:right;">&#8377; ${fmt(data.pricing.roundOff)}</td>
        </tr>

        <!-- ROW 8 — EX SHOWROOM -->
        <tr>
          <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f14};font-weight:bold;">EX SHOWROOM</td>
          <td style="border:1px solid #000;border-top:none;border-left:none;${cp};${f14};font-weight:bold;text-align:right;">&#8377; ${fmt(data.pricing.exShowroomPrice)}</td>
        </tr>

      </tbody>
    </table>

    <!-- AMOUNT IN WORDS -->
    <div style="border:1px solid #000;border-top:none;${cp};">
      <div style="${f12};font-weight:bold;margin-bottom:3px;">Amount (in words)</div>
      <div style="${f12};font-style:italic;">${toWords(data.pricing.totalAmount)}</div>
    </div>

    <!-- FINANCE INFO HEADER -->
    <div style="text-align:center;font-weight:bold;font-size:12px;border:1px solid #000;border-top:none;${cph};background:#e0e0e0;letter-spacing:4px;">
      Finance Info
    </div>

    <!-- BIKE + PAYMENT DETAILS TABLE -->
    <table style="width:100%;border-collapse:collapse;">
      ${descRows()}
    </table>

    <!-- BANK + SIGNATURE -->
    <div style="display:flex;margin-top:6px;">

      <!-- Bank Details -->
      <div style="flex:1;border:1px solid #000;${cp};${f11};line-height:1.9;
                  position:relative;min-height:140px;padding:8px;">
        <div style="font-weight:bold;margin-bottom:3px;">
          Bank / Payment Details
        </div>
        <div>BANK - ${shopAddr.bankName}</div>
        <div>A/C Name - ${shopAddr.acName}</div>
        <div>A/C NO - ${shopAddr.acNo}</div>
        <div>IFSC CODE - ${shopAddr.ifsc}</div>
        <!-- QR Image -->
        <div style="position:absolute;top:8px;right:8px;">
          <img
            src="/bankali.png"
            alt="QR Code"
            style="width:100px;height:100px;object-fit:contain;"
          />
        </div>
      </div>

      <!-- Signature Block -->
      <div style="flex:1;border:1px solid #000;border-left:none;
                  ${cp};display:flex;flex-direction:column;
                  justify-content:flex-end;min-height:140px;padding:8px;">
        <div style="display:flex;justify-content:space-between;align-items:flex-end;">
          <div style="text-align:center;">
            <div style="border-top:1.5px solid #000;width:115px;margin-bottom:3px;"></div>
            <div style="font-size:10px;font-weight:bold;">Customer Sign</div>
          </div>
          <div style="text-align:center;">
            <div style="border-top:1.5px solid #000;width:125px;margin-bottom:3px;"></div>
            <div style="font-size:10px;font-weight:bold;">Authorised Signatory</div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <!-- END BORDERED INVOICE BODY -->

  <!-- Bengali notes — only for SCOOTY (hidden for E_RICKSHAW) -->
  ${b?.vehicleType !== "E_RICKSHAW" ? `
  <div style="
    margin-top:10px;
    font-family:'Noto Sans Bengali',Arial,sans-serif;
    font-size:13px;
    color:#000;
    line-height:2;
    padding:0 4px;
  ">
    <div style="font-weight:bold;margin-bottom:4px;">বিশেষ দ্রষ্টব্য :</div>
    <div style="display:flex;gap:6px;">
      <span style="min-width:20px;font-weight:600;">১.</span>
      <span>মাইলেজ সমস্যা হলে- নির্ধারিত মাইলেজ পরীক্ষার জন্য একজন ব্যক্তি সিঙ্গেল মুডে চালিয়ে নির্ধারিত করা হবে।</span>
    </div>
    <div style="display:flex;gap:6px;">
      <span style="min-width:20px;font-weight:600;">২.</span>
      <span>ব্যাটিরির সমস্যা হলে - প্রতিবছর ১০% করে কমেত থাকবে।</span>
    </div>
    <div style="display:flex;gap:6px;">
      <span style="min-width:20px;font-weight:600;">৩.</span>
      <span>উল্লেখিত ওয়ারেন্টি জন্য বছরে ৪ টি সার্ভিস সম্পূর্ণ করতে হবে।</span>
    </div>
      <div style="display:flex;gap:6px;">
      <span style="min-width:20px;font-weight:600;">8.</span>
      <span>জলে পড়ে গেলে বা পুড়ে গেলে পার্টসের  ওয়ারেন্টির মধ্যে আসবে না।</span>
    </div>
  </div>
  ` : ""}

</div>
`;

  /* ── print handler ─────────────────────────────────────────────────────── */
  const handlePrint = () => {
    const win = window.open("", "", "width=1100,height=900");
    win.document.write(`
      <html>
        <head>
          <title>Tax Invoice - ${data.invoice.invoiceNo}</title>
          <link rel="preconnect" href="https://fonts.googleapis.com">
          <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+Bengali:wght@400;600;700&display=swap" rel="stylesheet">
          <style>
            @page { size: A4; margin: 8mm 10mm; }
            body  { margin: 0; padding: 0; background: #fff; }
            *     { box-sizing: border-box; }
          </style>
        </head>
        <body>
          ${getInvoiceHTML(true)}
          <scr` + `ipt>
            window.onload = function() {
              window.print();
              window.onafterprint = function() { window.close(); };
            };
          </scr` + `ipt>
        </body>
      </html>
    `);
    win.document.close();
  };

  /* ── render ────────────────────────────────────────────────────────────── */
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { borderRadius: 2, bgcolor: "#d4d4d4" } }}
    >
      <Box sx={{ p: 1.5, bgcolor: "#d4d4d4" }}>
        <Box display="flex" justifyContent="flex-end" alignItems="center" mb={1.5} gap={1}>
          <Button
            variant="contained"
            onClick={handlePrint}
            sx={{ bgcolor: "#0d1b2a", borderRadius: 2, fontWeight: 700, "&:hover": { bgcolor: "#1a3a5c" } }}
          >
            🖨️ Print / Save PDF
          </Button>
          <Button variant="outlined" onClick={onClose} sx={{ borderRadius: 2, fontWeight: 700 }}>
            Close
          </Button>
        </Box>
        <Box
          sx={{ bgcolor: "#fff", borderRadius: 1, overflow: "auto" }}
          dangerouslySetInnerHTML={{ __html: getInvoiceHTML(false) }}
        />
      </Box>
    </Dialog>
  );
};

export default InvoicePopup;
